import { useGetTargetareStats } from "@/hooks/api/query/useGetTargetareStats";
import { formatDataOra, formatNumar } from "@/utils/targetareFormatting";
import { HeroPagina } from "@/pages/AdministrareTargetare/components/HeroPagina";

export default function AdministrareStatistici() {
  const stats = useGetTargetareStats();
  const date = stats.data;

  return (
    <div className="container mx-auto max-w-[1400px] space-y-6 p-6">
      <div className="space-y-1">
        <h1 className="text-3xl font-heading font-bold">Statistici</h1>
        <p className="max-w-3xl text-muted-foreground">
          Schelet pentru identificarea posibililor clienți și pentru business
          intelligence pe universul de targetare. Conținutul complet (pâlnie,
          acoperirea listelor, evoluția între snapshot-uri, filtre pe sector ×
          județ × dimensiune) vine în Faza 5; aici sunt doar reperele care
          există deja.
        </p>
      </div>

      {stats.error && (
        <p className="rounded-md border border-destructive/40 bg-destructive/10 p-3 text-sm text-destructive">
          Statisticile nu au putut fi încărcate: {stats.error.message}
        </p>
      )}

      <HeroPagina
        titlu="Universul de targetare"
        isLoading={stats.isLoading}
        coloane={5}
        tiles={[
          { eticheta: "Firme active", valoare: date?.firme_active },
          { eticheta: "Bilanțuri", valoare: date?.bilanturi },
          { eticheta: "Clasificate", valoare: date?.clasificate },
          { eticheta: "În scop", valoare: date?.in_scop, ton: "bun" },
          {
            eticheta: "Coduri CAEN curente",
            valoare: date?.coduri_caen_curente,
          },
        ]}
      />

      <HeroPagina
        titlu="Prospețimea datelor"
        isLoading={stats.isLoading}
        coloane={4}
        tiles={[
          {
            eticheta: "Snapshot ONRC activ",
            valoare: date?.snapshot_onrc_activ?.eticheta ?? "–",
            detaliu: date?.snapshot_onrc_activ
              ? `importat ${formatDataOra(date.snapshot_onrc_activ.importat_la)}`
              : undefined,
          },
          {
            eticheta: "Snapshot ANAF activ",
            valoare: date?.snapshot_anaf_activ?.eticheta ?? "–",
            detaliu: date?.snapshot_anaf_activ
              ? `importat ${formatDataOra(date.snapshot_anaf_activ.importat_la)}`
              : undefined,
          },
          {
            eticheta: "Snapshot bilanț activ",
            valoare: date?.snapshot_bilant_activ?.eticheta ?? "–",
            detaliu: date?.snapshot_bilant_activ
              ? `importat ${formatDataOra(date.snapshot_bilant_activ.importat_la)}`
              : undefined,
          },
          {
            eticheta: "Interogări ANAF live (24h)",
            valoare: date?.anaf_24h,
          },
        ]}
      />

      <div className="grid gap-4 md:grid-cols-2">
        <div className="rounded-md border">
          <p className="border-b px-3 py-2 text-sm font-medium">
            Firme pe tier
          </p>
          <table className="w-full text-sm">
            <tbody>
              {Object.entries(date?.pe_tier ?? {}).map(([tier, n]) => (
                <tr key={tier} className="border-t">
                  <td className="px-3 py-1.5">{tier}</td>
                  <td className="px-3 py-1.5 text-right tabular-nums">
                    {formatNumar(n)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="rounded-md border">
          <p className="border-b px-3 py-2 text-sm font-medium">
            Firme pe dimensiune
          </p>
          <table className="w-full text-sm">
            <tbody>
              {Object.entries(date?.pe_dimensiune ?? {}).map(([d, n]) => (
                <tr key={d} className="border-t">
                  <td className="px-3 py-1.5">{d}</td>
                  <td className="px-3 py-1.5 text-right tabular-nums">
                    {formatNumar(n)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <p className="text-sm text-muted-foreground">
        Statistici calculate la{" "}
        {date?.statistici_la ? formatDataOra(date.statistici_la) : "–"}.
      </p>
    </div>
  );
}
